/**
 * Event handlers take precedence over HTML input elements, so we need to check in some event listeners whether the event is actually intended to go to an overlapping input element.
 * @param element Element to check.
 * @returns True if the HTMLElement is a HTML input element or part of dat.gui.
 */
export function htmlElementIsGUI(element: EventTarget | null): boolean {
  if (!(element instanceof HTMLElement)) {
    return false;
  }

  const inputElementTypes = [
    HTMLSelectElement,
    HTMLInputElement,
    HTMLButtonElement,
    HTMLOptionElement,
    HTMLTextAreaElement,
    HTMLLabelElement,
  ];
  for (const inputElementType of inputElementTypes) {
    if (element instanceof inputElementType) {
      return true;
    }
  }

  // Check if the element is part of dat.gui
  let htmlElement: HTMLElement | null = element;
  while (htmlElement) {
    if (htmlElement.className === "dg main" || htmlElement.className === "dg") {
      return true;
    }
    htmlElement = htmlElement.parentElement;
  }
  return false;
}
